<template>
  <ul class="sidebar-menu">
    <li tag="li" class="pageLink" @click="reload">
      <a>
        <i class="fa fa-repeat"></i>
        <span class="page">Actualizar datos</span>
      </a>
    </li>
    <li class="header" v-if="user" >OPERACIONES</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-home"></i>
        <span class="page">Inicio</span>
      </a>
    </router-link>
    <router-link v-if="false" tag="li" class="pageLink" to="/individual">
      <a>
        <i class="fa fa-search"></i>
        <span class="page">Consulta individual</span>
      </a>
    </router-link>
    <li class="header">CUENTA</li>
    <router-link tag="li" class="pageLink" to="/login" v-if="!user"></div>
      <a>
        <i class="fas fa-sign-in-alt text-yellow"></i>
        <span class="page">Ingresar al Portal</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/changePsw" v-if="user">
      <a>
        <i class="fas fa-key"></i>
        <span class="page">Cambiar clave</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/selfdata" v-if="user">
      <a>
        <i class="fa fa-user"></i>
        <span class="page">Mis datos</span>
      </a>
    </router-link>
    <router-link tag="li" class="pageLink" to="/comments" v-if="user && false">
      <a>
        <i class="fa fa-refresh"></i>
        <span class="page">Actualice sus datos</span>
      </a>
    </router-link>
    <!--<router-link tag="li" class="pageLink" to="/solicitud" v-if="!user">
      <a>
        <i class="fa fa-user-plus"></i>
        <span class="page">Solicitar usuario del Portal</span>
      </a>
    </router-link>-->
    <li style="cursor: pointer" class="pageLink" @click="logout" v-if="user">
      <a>
        <i class="fa fa-sign-out-alt text-red"></i>
        <span class="page">Cerrar Sesión</span>
      </a>
    </li>
    
    
  </ul>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'SidebarName',
  data: function () {
    return {
      menu: ''
    }
  },
  computed: {
    ...mapState([
      'userInfo', 'user'
    ])
  },
  methods: {
    logout () {
      this.$confirm('¿Realmente desea cerrar sesión?', 'Advertencia', {
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar',
        type: 'warning',
        lockScroll: false
      })
      .then(() => {
        localStorage.removeItem('user')
        this.$store.commit('SET_USER', '')
        this.$store.commit('SET_TOKEN', '')
        this.$store.commit('SET_MESSAGES', '')
        this.$store.commit('SET_PROVMESSAGES', '')
        window.localStorage.removeItem('token')
        this.$router.push('/login')
      })
      .catch(() => {})
    },
    reload () {
      location.replace('./')
    }
  }
}
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?2240512a